import { render, staticRenderFns } from "./BillsListItem.vue?vue&type=template&id=7fa12fe4&scoped=true"
import script from "./BillsListItem.vue?vue&type=script&lang=js"
export * from "./BillsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa12fe4",
  null
  
)

export default component.exports